export const createMarkup = (html) => {
  return {
    __html: html,
  };
};

export const formatCurrency = (input) => {
  if (!input || isNaN(input)) return "";

  // Remove all existing commas before converting
  // This is not required if the normalize method is implemented and already removing commas
  const cleanedInput = input.replace(/[$,]/g, "");

  // Convert to currency format
  const convertedInput = new Intl.NumberFormat().format(
    parseInt(cleanedInput, 10)
  );

  return "$" + convertedInput;
};

export const formatCurrencyDecimals = (input) => {
  if (!input || isNaN(input)) return "";

  // Remove all existing commas before converting
  // This is not required if the normalize method is implemented and already removing commas
  const cleanedInput = input.replace(/[$,]/g, "");

  return "$" + cleanedInput;
};

export const normalizeCurrency = (val) => {
  return val.replace(/[$,]/g, "");
};

export const formatPercentage = (input) => {
  if (!input || isNaN(input)) return "";

  // Remove all existing commas before converting
  // This is not required if the normalize method is implemented and already removing commas
  const cleanedInput = input.replace(/[,%]/g, "");

  return cleanedInput + "%";
};

export const normalizePercentage = (val) => {
  return val.replace(/[,%]/g, "");
};

export const htmlEncodeIds = (value) => {
  return value.replace(/[^0-9a-zA-Z]+/g, "");
};

export const formatBytes = (bytes, decimalPoint) => {
  if (bytes === 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const removeWorkCategory = (data, categoriesToRemove) => {
  const removeWorkCategories = (categoriesToRemove) => {
    for (var j = 0; j < data.length; j++) {
      if (data[j] && data[j].category === categoriesToRemove) {
        return data.splice(j, 1);
      }
    }
  };

  categoriesToRemove.forEach(removeWorkCategories);
};

export const removeUnwantedFiles = (attachments, deleteFile, ownerToRemove) => {
  // Remove unwanted files from catagories that do not exist
  let uploadedFiles = document.querySelectorAll(".list-uploadFile .list-tile");
  let labels = [];

  // If 'remove owner' occurs, need to remove consentLetter for removed owner and shift all consentLetter attachments ID number to 1 less
  if (ownerToRemove) {
    var elementPos = attachments
      .map((x) => {
        return x.id;
      })
      .indexOf(`consentLetter-owner` + ownerToRemove);

    if (elementPos !== -1) {
      deleteFile(attachments[elementPos].transactionID);

      for (var i = 0; i < attachments.length; i++) {
        if (attachments[i].id.match(/^consentLetter-owner.*/)) {
          const numberToMatch = attachments[i].id.match(/([0-9]+)/);
          if (numberToMatch[0] > ownerToRemove) {
            attachments[i].id = attachments[i].id.replace(
              /([0-9]+)/g,
              numberToMatch[0] - 1
            );
          }
        }
      }
    }
  } else {
    // Remove attachments that their corresponding attachment section is not present on the supporting documents page anymore
    for (let i = 0; i < uploadedFiles.length; i++) {
      if (uploadedFiles[i].attributes.label) {
        labels.push(uploadedFiles[i].attributes.label.value);
      }
    }

    const res = attachments.filter((file) => {
      return labels.indexOf(file.id) < 0;
    });

    for (let j = 0; j < res.length; j++) {
      deleteFile(res[j].transactionID);
    }
  }
};

export const jumpToError = () => {
  setTimeout(() => {
    let errors = document.querySelectorAll(".sq-form-error");
    if (errors.length > 0) {
      errors[0].parentNode.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, 0);
};
